import type { Component } from "vue";
import type { DocsLanguages } from "@/models/documentation";
import type { PerspectiveViewConfig } from "@/models/perspective";

// Type definition for the docs module vuex state object.
export interface DocsState {
  drawerComponents: Component[];
  getUpdate: boolean;
  language: DocsLanguages | undefined;
  tableConfiguration: PerspectiveViewConfig;
  tableSchema: Record<string, string>;
  shouldClearTable: boolean;
  applyConfiguration: boolean;
}

/**
 * Create a state object for the docs module.
 * @returns A state object initialized for use in the docs module.
 */
export function makeState(): DocsState {
  return {
    drawerComponents: [],
    getUpdate: false,
    language: undefined,
    tableConfiguration: {
      aggregates: {},
      group_by: [],
      columns: [],
      expressions: [],
      filter: [],
      plugin: "Datagrid",
      plugin_config: {
        scroll_lock: false,
        editable: false,
        columns: {},
      },
      split_by: [],
      settings: true,
      sort: [],
    },
    tableSchema: {
      id: "string",
      timestamp: "datetime",
      timeElapsedMs: "integer",
      severity: "string",
      message: "string",
      language: "string",
      libraryName: "string",
      libraryVersion: "string",
      serviceInstanceId: "string",
      serviceName: "string",
      serviceNamespace: "string",
      serviceVersion: "string",
    },
    shouldClearTable: false,
    applyConfiguration: false,
  };
}
